import { Container, Sprite } from '@pixi/react';
import { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { useOutSideClick } from '../../../core/hooks/useOutSideClick';
import QuickBetsPagination from '../quickBetsPagination';
import { getGameImages } from '../../../core/helpers/getGameImages';
import ClassicQuickBetsList from '../classicQuickBetsList';

const ClassicQuickBetsListPopup = observer(({ x, y, pagination, quickBetsList }) => {
  const {
    quickBetsByPage,
    quickBetsPaginationList,
    isShowQuickBetsListPopup,
    setIsShowQuickBetsListPopup,
  } = bettingPartStore;
  const [popupRef, isOutsideClick] = useOutSideClick();
  const { quickBetsListPopupBackground } = useMemo(() => {
    return getGameImages();
  }, []);

  useEffect(() => {
    if (isOutsideClick && isShowQuickBetsListPopup) {
      setIsShowQuickBetsListPopup(false);
    }
  }, [isOutsideClick, isShowQuickBetsListPopup, setIsShowQuickBetsListPopup]);

  if (!isShowQuickBetsListPopup) {
    return null;
  }
  return (
    <Container x={x} y={y} name='QuickBetsListPopup' ref={popupRef}>
      <Sprite texture={quickBetsListPopupBackground} alpha={0.85} />
      <ClassicQuickBetsList
        quickBetsByPage={quickBetsByPage}
        x={quickBetsList.x}
        y={quickBetsList.y}
        quickBetMargin={quickBetsList.elementMargin}
      />
      <QuickBetsPagination
        quickBetsPaginationList={quickBetsPaginationList}
        quickBetsPaginationElementMargin={pagination.elementMargin}
        x={pagination.x}
        y={pagination.y}
      />
    </Container>
  );
});
export default ClassicQuickBetsListPopup;
